
import Dialog from './dialog';
var Bee = function () {

}
function TwofactorSCodeInput() {
    var bee = null;
    var defered = null;

    function createPromise() {
        return new Promise(function (resolve, reject) {
            defered = { resolve: resolve, reject: reject };
        });
    }

    function updateButtonStatus() {
        if (bee) {
            Dialog.toggleBtnDisable(bee.disabled || !/^\d{6}$/.test(bee.scode));
        }
    }

    this.show = function () {
        var promise = createPromise();
        var mount = function () {
            bee = Bee.mount('twofactor-scode-dialog', {
                scode: '',
                disabled: false
            });
            var scodeChanged = function () {
                bee.$set('error', null);
                updateButtonStatus();
            };
            scodeChanged();
            bee.$watch('scode', scodeChanged);
        };

        Dialog.create(TEMPLATE.TWOFACTORSCODE, 480, null, {
            title: "验证动态密码",
            button: {
                '确定': function () {
                    defered.resolve(bee.scode);
                }
            },
            onload: mount,
            defaultCancelCb: defered.reject
        });
        return promise;
    };
    this.disable = function (value) {
        if (bee) {
            bee.$set('disabled', value);
            updateButtonStatus();
        }
    };
    this.retry = function (errorMessage) {
        if (bee) {
            bee.$set('error', errorMessage);
            var input = $(bee.$el).find('input')[0];
            try {
                input.select();
                input.focus();
            } catch (e) {

            }
            return createPromise();
        }
    };
    this.hide = function () {
        if (bee) {
            bee.$destroy();
            Dialog.hide();
        }
        bee = null;
        defered = null;
    }
}

export default new TwofactorSCodeInput();

